export default {
	meta: {
		title: 'Mot de passe oublié',
		description: 'Mot de passe oublié'
	},
	title: 'Mot de passe oublié',
	description: 'Veuillez saisir votre adresse e-mail ci-dessous. Nous vous enverrons les instructions pour créer un nouveau mot de passe.',
	sendBtn: 'Réinitialiser mon mot de passe',
	backLoginBtn: 'Retour à la page de connexion',
	success: {
		title: 'Mot de passe oublié',
		message: 'Vous allez recevoir un e-mail sur l’adresse {email} contenant un lien sécurisé. Merci de cliquer sur ce lien pour valider votre adresse e-mail.',
		info: 'Ce lien expirera au bout de 24 heures.'
	}
};
